// LAC official logo — uploaded by founder
export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_lac-customs-booking/artifacts/xtamfs3o_EA56218E-80A1-4E76-ABA4-E0E1688862B2.png";

export default function LacBadge({ size = 48, withSubtitle = false, className = "" }) {
  return (
    <div className={`inline-flex flex-col items-center ${className}`} aria-label="London Automotive Customs">
      <img
        src={LOGO_URL}
        alt="LAC — London Automotive Customs"
        width={size}
        height={size}
        loading="eager"
        decoding="async"
        className="select-none rounded-full object-contain"
        style={{ width: size, height: size, filter: "drop-shadow(0 0 18px rgba(217,70,239,0.35))" }}
        data-testid="lac-logo"
      />
      {withSubtitle && (
        <div className="mt-2 text-[10px] tracking-[0.3em] text-zinc-500">@lac.ltd</div>
      )}
    </div>
  );
}
